import * as React from 'react';
import './../index.css';
import './../fonts/Bakerie/BakerieSmoothCondensed-Black.otf';
import { getDocs, collection, query, orderBy, deleteDoc, doc } from "firebase/firestore";
import { database } from '../firebase-config';
import { Container, Stack, Button, Table, Form, Row, Col } from "react-bootstrap";
import Modal from "react-modal";
import { PackagingForm } from './PackagingForm';
import { CustomizedTypeahead } from './CustomizedTypeahead';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import 'react-bootstrap-typeahead/css/Typeahead.bs5.css';
import Dropdown from 'react-bootstrap/Dropdown';
import DropdownButton from 'react-bootstrap/DropdownButton';
import ToggleButton from 'react-toggle-button';
import { Timestamp } from "firebase/firestore";
import { Settings, getSettings, documentToSettings } from '../data/SettingsData';
import { getReferenceName } from '../utils/ReferendeUtils';
import { getPackaging, getPackagings, Packagings, savePackaging, recordHistory, getDocData } from '../data/PackagingData';



export class PackagingList extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      packagings: new Packagings(),
      allDocs: [],
      docRef: "",
      docMap: new Map(),
      refMap: new Map(),
      options: new Array(),
      previousRef: "",
      isDeleteConfirmOpen: false,
      description: "",
      deleteDocRef: "",
      mode: "Add",
      showForm: false,
      didSave: true,
      show_deleted: false,
      settings: new Settings(),
    };
    this.handleDelete = this.handleDelete.bind(this);
    this.toggleDeleteModal = this.toggleDeleteModal.bind(this);
    this.toggleMode = this.toggleMode.bind(this);
    this.handleUpdate = this.handleUpdate.bind(this);
    this.COLLECTION = "packaging";

  }

  toggleShowForm = () => {
    this.setState({
      showForm: !this.state.showForm,
      docMap: new Map(),
      didSave: true,
    }, () => {
      this.readPackingMaps(this.state.show_deleted);
    });

  }

  toggleMode = (mode) => {
    this.setState({
      docRef: "",
      mode: mode,
      showForm: true,
      didSave: false,
    });
  }


  toggleDeleteModal = (docRef, description) => {
    this.setState({
      deleteDocRef: docRef,
      description: description,
      isDeleteConfirmOpen: !this.state.isDeleteConfirmOpen,
    });
  }

  handleUpdate = async (docRef) => {
    this.setState({
      docRef: docRef,
      showForm: true,
      mode: 'Edit',
      didSave: false,
    });
  }

  handleDelete = async (docRef) => {
    let newHistoryList = new Array();
    let now = Timestamp.now();
    let packagingDoc = await getPackaging(docRef);
    let packaging = packagingDoc.data();
    packaging.is_deleted = !packaging.is_deleted;
    newHistoryList = packaging.history;
    let cost_changed = await recordHistory(newHistoryList, now, packaging, docRef);
    packaging.history = newHistoryList;

    let docData = getDocData(packaging);

    await savePackaging(docRef, docData, cost_changed);
    this.readPackingMaps(this.state.show_deleted);

  }
 async loadSettings() {
    let docReference = getReferenceName(this.props.context.user.email);
    let tempSettingsDoc = await getSettings(docReference);
    let settings = documentToSettings(tempSettingsDoc);
    return settings;
  }

  async readPackingMaps(show_deleted) {
    let packagings = await getPackagings(show_deleted);
    let settings = await this.loadSettings();

    this.setState({
      packagings: packagings,
      settings: settings,
    });
  }



  componentDidMount() {
    this.readPackingMaps();
    window.addEventListener('beforeunload', this.beforeunload.bind(this));
  }

  componentWillUnmount() {
    window.removeEventListener('beforeunload', this.beforeunload.bind(this));
  }

  beforeunload(e) {
    if (!this.state.didSave) {
      e.preventDefault();
      e.returnValue = '';
    }
  }

  scrollToView(ref) {
    if (this.state.previousRef !== '' && this.state.previousRef.current) {
      let oldRef = this.state.previousRef;
      oldRef.current.style.background = 'white';
      this.setState({
        previousRef: "",
      })
    }
    setTimeout(() => {
      ref.current.scrollIntoView({
        behavior: "smooth",
        block: "center",
        inline: "center",
      });
      ref.current.style.background = 'gray';
      this.setState({
        previousRef: ref,
      })
    });
  }

  renderTableRow = (docRef, doc) => {
    let deleteText = "";
    let deleted = "";
    if (doc.is_deleted) {
      deleteText = "Undelete"
      deleted = "Y"
    } else {
      deleteText = "Delete"
      deleted = "N"
    }

    return (
      <tr key={docRef} ref={this.state.refMap.get(docRef)}>
        <td>{doc.description}</td>
        <td>{doc.cost}</td>
        <td>{doc.per}</td>
        <td>{doc.total_price}</td>
        <td>{doc.total_quantity}</td>
        <td>{doc.information}</td>
        {this.state.show_deleted && <td show={this.state.show_deleted}>{deleted}</td>}
        <td>
          <DropdownButton variant="dark" id="dropdown-basic-button" title="Actions">
            <Dropdown.Item variant="dark" onClick={() => { this.handleUpdate(docRef) }}>Edit</Dropdown.Item>
            <Dropdown.Item variant="dark" onClick={() => { this.handleDelete(docRef) }}>{deleteText}</Dropdown.Item>
          </DropdownButton>
        </td>
      </tr>
    );

  }


  render() {

    let docMap = this.state.packagings.docMap;

    return (
      <>
        {
          /* 
          * Packaging List
          */
        }
        <Stack gap={3}>
          {!this.state.showForm &&
            <Container fluid>
              <Row className="justify-content-md-left">
                <Col>
                  <h2>Packaging:</h2>
                </Col>
                <Col>
                  <Button variant="dark" onClick={() => { this.toggleMode('Add') }}>Add New Packaging</Button>
                </Col>
                <Col>
                  <label htmlFor="show_deleted">Show Deleted?</label>
                  <ToggleButton
                    id="show_deleted"
                    inactiveLabel={'No'}
                    activeLabel={'Yes'}
                    value={this.state.show_deleted}
                    onToggle={(value) => {
                      this.setState({
                        show_deleted: !this.state.show_deleted,
                      }, () => {
                        this.readPackingMaps(this.state.show_deleted);
                      })
                    }} />
                </Col>
                <Col md="auto">
                  Find:
                </Col>
                <Col md="auto">
                  <CustomizedTypeahead
                    onChange={(selected) => {
                      //console.log("selected" + selected);
                      if (selected.length > 0) {
                        let ref = this.state.packagings.refMap.get(selected[0].id);
                        this.scrollToView(ref);
                      }
                    }}
                    align='left'
                    labelKey={'value'}
                    options={this.state.packagings.options}
                  />
                </Col>
              </Row>
            </Container>
          }
          {this.state.showForm &&
            <PackagingForm
              docRef={this.state.docRef}
              mode={this.state.mode}
              toggleForm={() => { this.toggleShowForm() }}
            />
          }
          <Modal
            className='modalDialog'
            isOpen={this.state.isDeleteConfirmOpen}
            onRequestClose={this.toggleModal}
            contentLabel="My dialog"
          >
            <div>
              Delete {this.state.description}?
            </div>
            <Button variant="dark" onClick={() => { this.toggleDeleteModal() }}>Cancel</Button>{' '}
            <Button variant="dark" onClick={() => { this.handleDelete(this.state.deleteDocRef) }}>Confirm</Button>
          </Modal>
          {!this.state.showForm &&
            <div className='scrollingTable'>
              <Table bordered hover>
                <thead>
                  <tr className='header'>
                    <th className='table-header'>Description</th>
                    <th className='table-header'>Cost</th>
                    <th className='table-header'>Per</th>
                    <th className='table-header'>Total Price</th>
                    <th className='table-header'>Total Quantity</th>
                    <th className='table-header'>Information</th>
                    {this.state.show_deleted && <th className='table-header'>Deleted?</th>}
                    <th className='table-header'></th>
                  </tr>
                </thead>
                <tbody>
                  {
                    [...docMap].map(([key, value]) => {
                      return this.renderTableRow(key, value);
                    }
                    )
                  }
                </tbody>
              </Table>
            </div>
          }
        </Stack>
      </>
    );

  }
}